import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';

//One offs
// Lazyload images
var myLazyLoad = new LazyLoad();

$( window ).on( 'load', () => {

  setTimeout( () => {
    $( '.sub-menu' ).addClass( 'visible' );
  }, 500 ) 

  $( '#toggle-menu' ).on( 'click', () => {
    $( '.nav' ).toggleClass( 'open' );
  });

  $( '.scroll-top' ).on( 'click', ( e ) => {
    e.preventDefault();
    $( 'html, body, .modal' ).scrollTop( 0 );
  });

  // check on load if the nav is checked uncheck it for when a user hits the back button
  if ( $( '#toggle-menu' ).is( ':checked' ) ) {
    $( '#toggle-menu' ).prop( 'checked', false );
  }

  // addding no scroll when the menu is open
  const checkbox = document.getElementById( 'toggle-menu' );

  // Hide and remove
  checkbox.addEventListener( 'change', () => {
    $( 'body' ).toggleClass( 'no-scroll' );
  });

   
  if ( $( '.menu-item-has-children' ).length ) {

    // DESKTOP HOVER STATE
    $( '.products-menu' ).on( 'mouseenter', function() {
      $( this ).parents( '.nav' ).addClass( 'sub-menu-hover' );
    });
    $( '.products-menu' ).on( 'mouseleave', function() {
      $( this ).parents( '.nav' ).removeClass( 'sub-menu-hover' );
    });

    $( '.products-menu' ).on( 'focus','a, li', function() {
      $( this ).parents( '.nav' ).addClass( 'sub-menu-hover' );
    });
    $( '.products-menu' ).on( 'focusout','a, li', function() {
      $( this ).parents( '.nav' ).removeClass( 'sub-menu-hover' );
    });

    // MOBILE NAV SUB MENU ACCORDION  
    $( '.products-menu > a' ).on( 'click', function(e) {
      e.preventDefault();

      var $this = $( this ).parent();
      var $content = $this.find( '.sub-menu' );

      if ( $this.parents( '.open' ).length ) {
        $this.parents( '.nav-primary' ).find( '.sub-menu' ).css( 'max-height', '0' );

        if ($this.hasClass( 'active' )) {
          $this.removeClass( 'active' );
        } else {
          $this.parents( '.nav-primary' ).find( '.menu-item-has-children' ).removeClass( 'active' );
          $this.addClass( 'active' );
          $content.css( 'max-height', $content[0].scrollHeight );
        }
      }
    });
    // $( '.products-menu .sub-menu' ).on( 'click', function(e) {
    //   e.stopPropagation();
    // });
    } 

  if( $( '.page-header' ).length ) {
    var position = $( window ).scrollTop(); 
    var navHeight = $( '.nav' ).height();
    var headerHeight = $( '.page-header' ).height() + navHeight;
    // should start at 0

    $( window ).on( 'scroll', () => {
      var scroll = $( window ).scrollTop();
      //if the user scrolls past the navigation height, adds position fixed 
      // and translates the menu -100%;
      if ( scroll >= navHeight ) { 
        $( '.nav' ).addClass( 'nav-fix' );
      } else {
        $( '.nav' ).removeClass( 'nav-fix' );
      }
      // when the user scrolls page the hero, adds a nav-animate class so 
      // the fixed nav can now animate
      if( scroll > position || scroll <= navHeight) { 
        $( '.nav' ).removeClass( 'nav-animate' );
      } else {
        $( '.nav' ).addClass( 'nav-animate' );
      }
      position = scroll;
      // when the user makes an upwards scroll the nav translates to 0% 
      // if it has the nav-animate class also
      if ( scroll >= headerHeight ) {
        $( '.nav' ).addClass( 'nav-show' );
      } else {
        $( '.nav' ).removeClass( 'nav-show' );
      }
    });
  } else {
    //for the sidebar nav pages so the nav stays at the top when scrolling
    $( '.nav' ).addClass( 'nav-stick' );
  }
});
$( document ).on( 'ready', function() {
  if ( window.location.hash.indexOf( 'thanks' ) > -1) {
    dataLayer.push( { 'event': 'register_complete', 'value': 'form_submit' } );
  }
});